import { Component, Input, OnInit, inject } from "@angular/core";
import { PropTenantAttribute } from "@app/integrations/urm/models/prop-tenant-attribute";
import { CautionService } from "@app/integrations/urm/services/caution.service";
import {
  PropTenantAttributeCode,
  TextAnonymisationBehaviour
} from "@app/integrations/urm/models/prop-tenant-attribute-code";
import { MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: "urm-tenant-caution-list-item",
  templateUrl: "./tenant-caution-list-item.component.html",
  styleUrls: ["./tenant-caution-list-item.component.css"],
  imports: [MatListItem, MatIcon, MatTooltip]
})
export class TenantCautionListItemComponent implements OnInit {
  protected cautionService = inject(CautionService);

  @Input()
  public caution: PropTenantAttribute;
  public cautionCode: PropTenantAttributeCode;
  hiddenFromOperative: boolean;
  loading: boolean = true;

  ngOnInit() {
    if (!this.caution) {
      return;
    }
    this.cautionService
      .tenantAttributeCodeLookup(this.caution.Ptat_TenantAttributeCodeID)
      .then((value) => {
        console.log("assigning caution code to attribute");
        this.cautionCode = value;
        this.loading = false;
        this.hiddenFromOperative =
          value.Ptac_TextAnonymisationBehaviour ===
          TextAnonymisationBehaviour.AlternateText;
      });
  }
}
